import http from '../utils/request'
let baseUrl = "/api/spread";
let api = "/config";
let ourGameApi = {
    /**
     * 获取服务器list
     * @param {Object} data
     */
    getServer(data) {
        return http({
            method: 'get',
            //url: api+'/serverlist.json',
            url: 'http://fmz.ourgame.com/config/serverlist.json',
            params: data
        })
    },
    /**
     * 获取弹幕list
     * @param {Object} data
     */
    getBarrage (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetBarrage',
            params: data
        })
    },
    /**
     * 获取奖品list
     * @param {Object} data
     */
    getRecord (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetRecord',
            params: data
        })
    },
    /**
     * 获取角色list
     * @param {Object} data
     */
    getRoleList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetRoleList',
            params: data
        })
    },
    /**
     * 登录
     * @param {Object} data
     */
    login (data) {
        return http({
            method: 'get',
            url: baseUrl+'/login',
            params: data
        })
    },
    /**
     * 发送弹幕
     * @param {Object} data
     */
    sendBarrage (data) {
        return http({
            method: 'get',
            url: baseUrl+'/sendBarrage',
            params: data
        })
    },
    /**
     * 登录状态
     * @param {Object} data
     */
    isLogined (data) {
        return http({
            method: 'get',
            url: baseUrl+'/IsLogined',
            params: data
        })
    },
    /**
     * 退出登录
     * @param {Object} data
     */
    loginOut (data) {
        return http({
            method: 'get',
            url: baseUrl+'/loginOut',
            params: data
        })
    },

    
    /**
     * 获取专属链接
     * @param {Object} data
     */
    getMyLinks (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetWinAwardList',
            params: data
        })
    },
    /**
     * 获取邀请阶段礼包
     * @param {Object} data
     */
    getInviteGift (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetInviteGift',
            params: data
        })
    },
    /**
     * 获取注册奖品礼包
     * @param {Object} data
     */
    getRegGift (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetWinAwardList',
            params: data
        })
    },
    /**
     * 我的奖品list
     * @param {Object} data
     */
    getWinAwardList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetWinAwardList',
            params: data
        })
    },
    /**
     * 初始化数据
     * @param {Object} data
     */
    initData (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetInviteAwardList',
            params: data
        })
    },
    /**
     * 获取抽奖次数
     * @param {Object} data
     */
    getDrawCount (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetDrawCount',
            params: data
        })
    },
    /**
     * 获取奖品信息
     * @param {Object} data
     */
    getAwardList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetAwardList',
            params: data
        })
    },

    /**
     * 所获得的奖品
     * @param {Object} data
     */
    getDrawResult (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetDrawResult',
            params: data
        })
    },
    bindRole(data){
        return http({
            method: 'get',
            url: baseUrl+'/BindRole',
            params: data
        })
    }
}
export default ourGameApi;


// WEBPACK FOOTER //
// ./src/api/api.js